<template>
  <div>
    <div class="reserved-text wordWrap" :style="styleObject">
      Copyright ©️ 2023 - {{ year }} The HKCCCU Logos Academy. All rights
      reserved.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    styleObject: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      year: 2024,
    };
  },
};
</script>

<style lang="scss" scoped>
.reserved-text {
  color: #000;
}
</style>